import BaseModel from './BaseModel';

export default class Menu extends BaseModel {
    constructor(data = {}) {
        super(data)
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.code = data.code || undefined;
        this.name = data.name || this.translate.name || undefined;
        this.outletId = data.fnbOutletId || data.outletId || undefined;
        this.outlets = Array.isArray(data.outlets) ? data.outlets : [];
        this.status = data.status || 0;
        this.isActive = typeof data.isActive === 'boolean' ? data.isActive : undefined;
        this.parentId = data.parentId || null; // For sub-menus
        this.level = data.level;
        
        // Structure
        this.subMenus = (data.subMenus || []).map(sm => new Menu(sm));
        this.items = data.items || []; // Just IDs or light objects, detailed items loaded separately potentially
    }
}
